import t from"./_getNative.js";import o from"./_root.js";var r=t(o,"Set");export{r as default};
//# sourceMappingURL=_Set.js.map
